module.exports = __webpack_public_path__ + "img/games08.00cced21.png";